/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OsmBuildingDto } from './OsmBuildingDto';
import {
    OsmBuildingDtoFromJSON,
    OsmBuildingDtoFromJSONTyped,
    OsmBuildingDtoToJSON,
    OsmBuildingDtoToJSONTyped,
} from './OsmBuildingDto';
import type { OrderDto } from './OrderDto';
import {
    OrderDtoFromJSON,
    OrderDtoFromJSONTyped,
    OrderDtoToJSON,
    OrderDtoToJSONTyped,
} from './OrderDto';

/**
 * 
 * @export
 * @interface CompanyDetailDto
 */
export interface CompanyDetailDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailDto
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailDto
     */
    rawCompanyData?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailDto
     */
    fullAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailDto
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailDto
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailDto
     */
    addition?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailDto
     */
    country?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailDto
     */
    lat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailDto
     */
    lon?: number | null;
    /**
     * 
     * @type {OsmBuildingDto}
     * @memberof CompanyDetailDto
     */
    osmBuilding?: OsmBuildingDto;
    /**
     * 
     * @type {Array<OrderDto>}
     * @memberof CompanyDetailDto
     */
    orders?: Array<OrderDto> | null;
}

/**
 * Check if a given object implements the CompanyDetailDto interface.
 */
export function instanceOfCompanyDetailDto(value: object): value is CompanyDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CompanyDetailDtoFromJSON(json: any): CompanyDetailDto {
    return CompanyDetailDtoFromJSONTyped(json, false);
}

export function CompanyDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'rawCompanyData': json['rawCompanyData'] == null ? undefined : json['rawCompanyData'],
        'fullAddress': json['fullAddress'] == null ? undefined : json['fullAddress'],
        'street': json['street'] == null ? undefined : json['street'],
        'number': json['number'] == null ? undefined : json['number'],
        'addition': json['addition'] == null ? undefined : json['addition'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lon': json['lon'] == null ? undefined : json['lon'],
        'osmBuilding': json['osmBuilding'] == null ? undefined : OsmBuildingDtoFromJSON(json['osmBuilding']),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(OrderDtoFromJSON)),
    };
}

export function CompanyDetailDtoToJSON(json: any): CompanyDetailDto {
    return CompanyDetailDtoToJSONTyped(json, false);
}

export function CompanyDetailDtoToJSONTyped(value?: CompanyDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'rawCompanyData': value['rawCompanyData'],
        'fullAddress': value['fullAddress'],
        'street': value['street'],
        'number': value['number'],
        'addition': value['addition'],
        'postalCode': value['postalCode'],
        'city': value['city'],
        'country': value['country'],
        'lat': value['lat'],
        'lon': value['lon'],
        'osmBuilding': OsmBuildingDtoToJSON(value['osmBuilding']),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(OrderDtoToJSON)),
    };
}

